"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
require("../sidebar/style/sidebar.css");
exports.default = (function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("div", { className: "page-wrapper chiller-theme toggled" },
        React.createElement("a", { className: "btn btn-sm btn-dark", href: "#" }),
        React.createElement("nav", { id: "sidebar", className: "sidebar-wrapper" },
            React.createElement("div", { className: "sidebar-content" },
                React.createElement("div", { className: "sidebar-brand" },
                    React.createElement("a", { href: "#" }, "SONAR AUTH")),
                React.createElement("div", { className: "sidebar-menu" },
                    React.createElement("ul", null,
                        React.createElement("li", { className: "sidebar-dropdown" },
                            React.createElement(react_router_dom_1.Link, { to: "/" },
                                " ",
                                React.createElement("i", { className: "fas fa-home" }),
                                React.createElement("span", null, "Home"))),
                        React.createElement("li", { className: "sidebar-dropdown" },
                            React.createElement(react_router_dom_1.Link, { to: "/Service" },
                                " ",
                                React.createElement("i", { className: "fas fa-code-branch" }),
                                React.createElement("span", null, "Service"))),
                        React.createElement("li", { className: "sidebar-dropdown" },
                            React.createElement(react_router_dom_1.Link, { to: "/Application" },
                                " ",
                                React.createElement("i", { className: "fas fa-mobile-alt" }),
                                React.createElement("span", null, "Application"))),
                        React.createElement("li", { className: "sidebar-dropdown" },
                            React.createElement(react_router_dom_1.Link, { to: "/KeyToken" },
                                " ",
                                React.createElement("i", { className: "fas fa-key" }),
                                React.createElement("span", null, "Key & Token")))))),
            React.createElement("div", { className: "sidebar-footer" },
                React.createElement("a", { href: "#" },
                    React.createElement("i", { className: "fa fa-power-off" })))),
        React.createElement("main", { className: "page-content" }, props.children)))); });
require("../style/ServiceInApplication.css");
//# sourceMappingURL=dashboardlayout.js.map